import { FaMapMarkedAlt, FaBorderAll, FaMagic, FaPenNib } from 'react-icons/fa';
import tourWelcome from '../assets/tour-welcome.png';
import tourWhatYouBuild from '../assets/tour-what-you-build.png';
import tourAiDrafts from '../assets/tour-ai-drafts.png';
import tourNextBuild from '../assets/tour-next-build.png';
// ─────────────────────────────────────────────────────────────────────────────
// MANAGER TOUR - the landing screen (Simulation list / Challenges).
//
// Voice: in-world. Vision Makers lore - Stalkers dive into Simulations to pull
// data the AI needs to evolve; here a Stalker BUILDS the Simulation worlds others
// dive into. Address the reader as "Stalker". Use the lore vocabulary (Simulation,
// Wild Simulation, dive in, loot/Data, AI Agent), not invented jargon. Still
// explain what each control does. Intro frames = centered cards; 'spotlight' steps
// highlight a CSS selector and dim the rest. Missing target → centered card.
// ─────────────────────────────────────────────────────────────────────────────
export const MANAGER_TOUR = {
    id: 'manager',
    seenKey: 'vm-tutorial-seen',
    steps: [
        // ── Intro frames: what this is ──────────────────────────────────────
        {
            id: 'welcome',
            kind: 'intro',
            icon: FaMapMarkedAlt,
            image: tourWelcome,
            title: 'Welcome to Vision Makers, Stalker',
            body: "Hey, Stalker - you're one of us now. Out there we dive into Simulations: synthetic worlds where every choice, every emotion, every mistake becomes data the AI needs to evolve. But it can't dream those worlds up alone - that's where we come in. This is where Vision Makers build the Simulations other Stalkers dive into. Let's get you building.",
        },
        {
            id: 'what-you-build',
            kind: 'intro',
            icon: FaBorderAll,
            image: tourWhatYouBuild,
            title: "What you're building",
            body: 'Every Simulation is a grid of cells - a world with its own rules. You seed it with obstacles Stalkers have to survive, mark the cell where they materialize when they dive in, and scatter the loot across the map: Data, resources, the raw material of AI evolution.',
        },
        {
            id: 'ai-and-flow',
            kind: 'intro',
            icon: FaMagic,
            image: tourAiDrafts,
            title: 'The AI drafts, you shape it',
            body: "Hand the system a concept and it forges a world - a story, an obstacle on every cell, matching art. But it can't make anything truly new without you; your choices are the missing ingredient. When the Simulation holds together you send it for review - once it's verified, Stalkers can dive in.",
        },
        // ── Spotlight tour: the main screen ─────────────────────────────────
        {
            id: 'nav',
            kind: 'spotlight',
            target: '.mode-switcher',
            placement: 'bottom',
            title: 'Simulations & Challenges',
            body: 'Switch between your own Simulations and Challenges - contracts with fixed constraints and exact data targets you have to hit.',
        },
        {
            id: 'add-level',
            kind: 'spotlight',
            target: '.create-button',
            placement: 'bottom',
            title: 'Build a new Simulation',
            body: 'Name the world, set its grid size, drop in a backdrop if you have one, then write the story yourself or let the AI draft it from your concept.',
        },
        {
            id: 'status',
            kind: 'spotlight',
            target: '.status-tabs',
            placement: 'bottom',
            title: 'Track every world',
            body: "Filter by stage - Draft while you're building, Pending while it's reviewed, then Approved (live) or Rejected with notes.",
        },
        {
            id: 'open-editor',
            kind: 'spotlight',
            target: '.item-card .primary-action',
            placement: 'auto',
            title: 'Step into the Simulation',
            body: 'This opens the editor, where the world actually takes shape. First time in, a short briefing walks you through it.',
        },
        {
            id: 'submit',
            kind: 'spotlight',
            target: '.item-card .pipeline-button',
            placement: 'auto',
            title: 'Submit for review',
            body: 'When the checklist reads green, send your Simulation up. Once it’s verified it goes live; track the status right here and resubmit after any notes.',
        },
        // ── Outro: hand off to the editor tour ──────────────────────────────
        {
            id: 'next-editor',
            kind: 'intro',
            icon: FaPenNib,
            image: tourNextBuild,
            title: 'Next: into the editor',
            body: 'Open any Simulation - or build a new one - and a briefing walks you through writing the story, seeding obstacles, and shaping each node. You can replay any briefing from the Tutorial button up top.',
        },
    ],
};
